if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();
  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  // main variant + qty
  const variantId = this.form.querySelector("[name='id']")?.value;
  const quantity = parseInt(this.form.querySelector("[name='quantity']")?.value || "1", 10);

  // any selected add-ons on the page
  const addOnCheckboxes = Array.from(document.querySelectorAll(".addon-checkbox")).filter(cb => cb.checked);

  // Generate a shared bundle id for 1:1 association
  const bundleId = `${Date.now()}-${Math.random().toString(36).slice(2,8)}`;

  const items = [
    {
      id: parseInt(variantId, 10),
      quantity,
      // put the bundle id on the PARENT so identical boards stay separate
      properties: { _bundle: bundleId } // leading "_" hides it in your cart template
    },
    ...addOnCheckboxes.map(cb => ({
      id: parseInt(cb.dataset.variantId, 10),
      quantity: quantity, // 1:1 with main; change to 1 if you always want one add-on
      properties: {
        _bundle: bundleId,     // links to parent
        _is_addon: "true",     // mark as child
        addon_title: cb.dataset.addonTitle || cb.getAttribute('data-addon-title') || 'Add-on'
      }
    }))
  ];

  const config = fetchConfig("javascript");
  config.headers["Content-Type"] = "application/json";
  config.body = JSON.stringify({ items });

  fetch("/cart/add.js", config)
    .then(res => res.json())
    .then(data => {
      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
      this.cart.renderContents(data);
    })
    .catch((e) => {
      console.error(e);
      this.handleErrorMessage("Could not add to cart.");
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      this.querySelector('.loading__spinner')?.classList.add('hidden');
      this.submitButton.removeAttribute('aria-disabled');
    });
}


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
